import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Lottie from 'react-lottie'

export default class LottieWrapper extends Component {
  static propTypes = {
    options: PropTypes.any.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    isStopped: PropTypes.bool.isRequired,
    isPaused: PropTypes.bool.isRequired,
  }

  render() {
    return <Lottie {...this.props} />
  }
}


// WEBPACK FOOTER //
// ./src/components/ui/lotties/LottieWrapper.js